import React from 'react'
import Theme from '@adsk/alloy-react-theme'
import styled from 'styled-components'
import { useTranslation } from '../../../../i18n'

const HeadingTitle = styled.h1`
	font-weight: lighter;
	text-align: center;
`
const HeaderComponent = (): JSX.Element => {
	const { t } = useTranslation()
	const { typography } = Theme
	return (
		<HeadingTitle style={typography.heading1}>
			{t('PROFILE_PHOTO')}
		</HeadingTitle>
	)
}
export default HeaderComponent
